import { FilterGroup } from 'components/Filters/components/FilterModal'
import { FilterStore } from 'components/Filters/FilterStore'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { HOTEL_AMENITIES, amenitySlug } from 'constants/hotelAmenities'

const HOTEL_AMENITY_OPTIONS = HOTEL_AMENITIES.map((a) => ({
  value: amenitySlug(a.key),
  label: a.label,
}))

export function LodgingAmenitiesFilterGroup({
  filterStore,
}: {
  filterStore: FilterStore
}) {
  return (
    <FilterGroup title="Hotel Amenities">
      <SelectFilter
        filterKey="hotel_amenities"
        title="Hotel Amenities"
        options={HOTEL_AMENITY_OPTIONS}
        filterStore={filterStore}
      />
    </FilterGroup>
  )
}
